export enum CreatedByType {
  Madar = 'MADAR',
  Admin = 'ADMIN',
  Customer = 'CUSTOMER',
  Fleet = 'FLEET',
  Driver = 'DRIVER',
  Receiver = 'RECEIVER',
  Organization = 'ORGANIZATION',
  Vendor = 'VENDOR',
  Bayan = 'Bayan',
  Cement = 'CEMENT',
  Barq = 'BARQ',
  Pharmaciaty = 'PHARMACIATY',
  Dal = 'DAL',
  Saee = 'SAEE',
  'Wfc@Madar' = 'WFC@MADAR',
  Tam2go = 'TAM2GO',
  Adam = 'ADAM',
  AlShrouk = 'ALSHROUK',
  SuperAdmin = 'SUPER_ADMIN',
}
